/* eslint-disable */
import BASE from '../../../../vue.config.js'
import 'prismjs'
import 'prismjs/themes/prism.css'
import Vue from 'vue/dist/vue.js'
import listado from '../../../assets/js/ScriptListadoGeneral.js'

export default {
 data() {
 	return{
 	 	alumnos:[],
	 	EstatusRegistro:'',
	 	estatus:1,
	 	del: false,
	 	idAlumno:'',
	 	pagina:'alumnos',
	 	permisoGuardar:0,
	 	permisoActivaInactivar:0,
	 	permisoEliminar:0,
	 	permisoConsultar:0,
	 	permisoInscripcion:0
	 }
},
	 methods: {
	 	ObtenerListadoAlumnos(status){

	      fetch(`${BASE.baseUrl}api/ListadoAlumnos/${status}`, {
	        method: 'GET',
	        headers: {
	        		   'Authorization': sessionStorage.getItem('token'),
	        		   'pagina':'alumnos',
	        		   'paginaOrigen':'listadoAlumnos'
	        		}
	      	})
	      .then(rs => rs.json())
	      .catch(error => console.log('error:', error))
	      .then(rs => {
	        if(rs.status == 200){
	          rs.result.alumnos.forEach((item, indx) => {
                //Se agrega color al estatus del alumnno
                item.colorStatus = item.estatusAlumno == 'Inscrito' ? 'success': 'warning';
                // console.log(item);

	            this.alumnos.push(item);
	          });
	          rs.result.permisos.forEach((item, indx) => {
	          	if (item.id == 1){ this.permisoGuardar = 1;}
	            if (item.id == 3){ this.permisoActivaInactivar = 1;}
	            if (item.id == 4){ this.permisoEliminar = 1;}
	            if (item.id == 5){ this.permisoConsultar = 1;}
	            if (item.id == 6){ this.permisoInscripcion = 1;}
	          });
	        }
	      });
	   	},

	   	ComboEstatus(){
	 		this.EstatusRegistro = [
		        { text: 'Activo', value: 1, isSelected: false  },
		        { text: 'Inactivo', value: 0, isSelected: false  },
		        { text: 'Todos', value: 2, isSelected: false  }
     		]
     	},

     	ConsultarAlumnos: function(event){
     		this.alumnos = [];
     		this.ObtenerListadoAlumnos(this.estatus);
     	},

     	CambiarStatus(id){
     		listado.methods.CambiarStatus(id,this.pagina);
     	},

     	EliminarRegistro(){
     		listado.methods.EliminarRegistro(this.idAlumno,this.pagina);
     		this.del = false;
     	}
	},
	mounted(){
		this.ObtenerListadoAlumnos(1);
	    this.ComboEstatus();
	}
}
